import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import predictAPI from "./../actions/predictAPI";

const initialState = {
  list: [],
  data: [],
  total: 0,
  loading: false,
  detail: {},
};
export const fetchPredictHistory = createAsyncThunk(
  "predict/fetchListHistory",
  async (params, thunkAPI) => {
    const response = await predictAPI.fetchPredictHistory(params);
    return response.data;
  },
);

export const fetchPredictHistoryDetail = createAsyncThunk(
  "predict/fetchListDetail",
  async (params, thunkAPI) => {
    const response = await predictAPI.fetchPredictDetail(params);
    return response.data;
  },
);

export const fetchPredictList = createAsyncThunk(
  "predict/fetchList",
  async (params, thunkAPI) => {
    const response = await predictAPI.getMatchesGuest(params);
    return response.data;
  },
);

export const createPredict = createAsyncThunk(
  "predict/create",
  async (params, thunkAPI) => {
    const response = await predictAPI.createPredict(params);
    return response.data;
  },
);

export const getPredictInfo = createAsyncThunk(
  "predict/fetchPredictInfo",
  async (id, thunkAPI) => {
    const response = await predictAPI.getMatchesInfo(id);
    return response.data;
  },
);

export const predictSlice = createSlice({
  name: "predict",
  initialState: initialState,
  reducers: {
    clearReducer: (state, action) => {
      state.data = [];
      state.list = [];
      state.detail = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPredictHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPredictHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPredictHistoryDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPredictHistoryDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(fetchPredictList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPredictList.fulfilled, (state, action) => {
        state.loading = false;
        // add exchange_turn flag if predict_count >= 1
        const listWithExchangeTurn = (action.payload.data || []).map(
          (item) => ({
            ...item,
            exchange_turn: (item?.predict_count || 0) >= 1 ? "true" : "false",
          }),
        );
        state.list = listWithExchangeTurn;
        state.total = action.payload.total;
      })
      .addCase(createPredict.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPredict.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getPredictInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPredictInfo.fulfilled, (state, action) => {
        state.loading = false;
        console.log("getPredictInfo.fulfilled payload:", action.payload);
        state.detail = action.payload;
      });
  },
});
export const { clearReducer } = predictSlice.actions;

export default predictSlice.reducer;
